module.exports = __webpack_public_path__ + "assets/media/navigations-dot.9e4ee8d1.svg";